<template>
  <v-container fluid pl-0 pr-0>
    <v-row align="center" justify="center" class="pt-6">
      <v-col cols="6">
        <CONTENT />
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="pt-6">
      <v-col cols="12">
        <MEMBERS />
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="pt-6">
      <v-col cols="12">
        <div>
          <p class="display-2 text-center font-weight-bold indigo--text">Faculty Advisor</p>
        </div>
        <MEM :author="faculty" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CONTENT from "../components/About/Content.vue";
import MEMBERS from "../components/About/Members.vue";
import MEM from "../components/Article/Author.vue";
export default {
  components: {
    CONTENT,
    MEMBERS,
    MEM
  },
  data: () => ({
    faculty: { name: "Marguerite Feitlowitz" }
  })
};
</script>